import React from "react";
import img1 from "../../../assets/img/quick-setup.svg";
import img2 from "../../../assets/img/easy-use.svg";
import img3 from "../../../assets/img/d-support.svg";

const Common = () => {
  return (
    <div className="col-lg-4 ps-5 d-none d-lg-block">
      <div className="row justify-content-between h-100 form-img-wrapper">
        <div className="col-12">
          <div className="mb-4">
            <img className="mb-3" src={img1} alt="" />
            <h6 className="text-dark-blue">Quick Setup</h6>
            <p className="text-grey-2">
              Set up your account effortlessly with our step-by-step guide.
            </p>
          </div>
        </div>
        <div className="col-12">
          <div className="mb-4">
            <img className="mb-3" src={img2} alt="" />
            <h6 className="text-dark-blue">Easy to use</h6>
            <p className="text-grey-2">
              Our platform is designed to be easy to use, even for first-time.
              users.
            </p>
          </div>
        </div>
        <div className="col-12">
          <div className="mb-4">
            <img className="mb-3" src={img3} alt="" />
            <h6 className="text-dark-blue">Dedicated Support</h6>
            <p className="text-grey-2">
              Our team provides dedicated support every step of the way.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Common;
